/* eslint-disable import/no-cycle */
import Button from './Button';
import TextArea from './TextArea';
import { keyMode, changeLang, pressShift } from './utils';

export default class Keyboard {
  constructor(props) {
    this.keyboard = document.createElement('div');
    this.funcInput = props;
  }

  createKeyboardWrapper() {
    this.keyboard.classList.add('keyboard');
    this.keyboard.classList.add('keyboard_hide');
    document.body.insertBefore(this.keyboard, document.querySelector('.root'));
    const but = new Button(this.funcInput);
    but.createButtons(keyMode.keyEn);
    but.keyEvent();
  }

  mouseEvent() {
    const keyboardKey = document.querySelectorAll('.keyboard-key');
    const keyLang = document.querySelectorAll('.keyboard-key')[64];

    keyboardKey.forEach((el) => {
      el.addEventListener('mousedown', () => {
        el.classList.add('keyboard-key__active');
        if (el.innerText === 'Shift') {
          pressShift('Shift', this.funcInput);
        }
        if (el === keyLang) {
          changeLang(keyLang, this.funcInput);
        }
      });
      el.addEventListener('mouseleave', () => {
        el.classList.remove('keyboard-key__active');
      });
      el.addEventListener('mouseup', () => {
        const area = new TextArea(this.funcInput);
        switch (el.innerText) {
          case 'Shift':
            pressShift('', this.funcInput);
            break;
          case 'CapsLock':
            pressShift('', this.funcInput);
            break;
          case '↑':
            area.changeCursorPosition();
            break;
          case '↓':
            area.changeCursorPosition();
            break;
          case '←':
            area.changeCursorPosition('ArrowLeft');
            break;
          case '→':
            area.changeCursorPosition('ArrowRight');
            break;
          default:
            area.inputKey(el.innerText);
            break;
        }
        el.classList.remove('keyboard-key__active');
      });
    });
  }
}
